import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { IProduct } from './../../../shared/models/products/product';
import { PurchaseStateService } from './../../../shared/services/purchase-state.service';
import { PayNowUser } from 'app/purchase/shared/models/payments/pay-now-user';

@Component({
  selector: 'app-paynowcheckout',
  templateUrl: './paynow-checkout.component.html'
})
export class PayNowCheckoutComponent implements OnInit {
  products: IProduct[];
  user: PayNowUser;

  constructor(private purchaseState: PurchaseStateService,
    private route: ActivatedRoute,
    private router: Router)
    { }

  ngOnInit() {
    this.products = this.purchaseState.currentState.products;    
    this.user = this.purchaseState.getPersonForPayNow();
  }

  onCancel() {
    this.router.navigate(['']);
  }

  onCheckout() {
    this.router.navigate(['practitioner/paynow/payment']);
  }
}
